import { render, staticRenderFns } from "./BpAccordion.vue?vue&type=template&id=75d3d2dc&"
import script from "./BpAccordion.vue?vue&type=script&lang=js&"
export * from "./BpAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d3d2dc')) {
      api.createRecord('75d3d2dc', component.options)
    } else {
      api.reload('75d3d2dc', component.options)
    }
    module.hot.accept("./BpAccordion.vue?vue&type=template&id=75d3d2dc&", function () {
      api.rerender('75d3d2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/styles/molecules/accordion/BpAccordion.vue"
export default component.exports